import supabase from "./supabase";
import { FunctionsHttpError } from "@supabase/supabase-js";

export interface ClassData {
  id: string;
  name: string;
  description?: string;
  semester: string;
  join_code?: string | null;
  user_id: string;
  settings: {
    class_time: string;
    reflection_requirements?: {
      min_words?: number;
      min_sentences?: number;
      enabled: boolean;
    };
  };
  created_at: string;
  platform: string;
  district_id?: string;
}

export async function getClasses(): Promise<{
  classes: ClassData[] | null;
  error: string | null;
}> {
  const { data, error } = await supabase.functions.invoke("getClasses");

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();
    return { classes: null, error: errorMessage.error };
  }

  return {
    classes: data?.classes || [],
    error: error?.message || null,
  };
}
